import { Injectable, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Navigator } from 'src/app/components/menu/navigator';
import { AppLinksService } from '../applinks/app-links.service';
import { removeSpace } from '../codeUtils';
import { ConfigService } from '../config/config.service';
import { EventsService } from '../event/event.service';
import { GameHubControllerService } from '../gameHub/game-hub-controller';
import { LobbyService } from '../lobby/lobby.service';
import { UserSessionService } from '../user-session/user-session.service';
import { UtilsService } from '../utils/utils.service';
import { WebcontentExecuteService } from './webcontent-execute.service';
import { CashierContentService } from '../cashier/cashier-content.service';

@Injectable({
  providedIn: 'root'
})

export class WebcontentService implements OnInit {

  public isAuthenticated: boolean = false;
  public homePage: any;
  public gameData: any;

  private _externalLinkSubject: any;
  public _externalLinkValue: any;

  constructor(
    public config: ConfigService,
    public events: EventsService,
    public gameHubControllerService: GameHubControllerService,
    private appLinks: AppLinksService,
    private webcontentExecuteService: WebcontentExecuteService,
    private readonly lobbyService: LobbyService,
    private readonly navigator: Navigator,
    private cashierContentService: CashierContentService,
    private readonly userSessionService: UserSessionService,
    private readonly utilsService: UtilsService,
  ) {
    this.setIframeEventListeners();
    this.homePage = this.config.getExternalLinks().payload.filter(link => link?.code == "homepage")[0]?.url;
    this._externalLinkSubject = new BehaviorSubject(this.homePage);
    this._externalLinkValue = this._externalLinkSubject.asObservable()
  }

  ngOnInit(): void {

  }

  private async checkAuthentication(): Promise<any> {
    return await this.userSessionService.isAuthenticated().then(res => {
      if (res) return true
    })
  }

  public setIframeEventListeners() {

    window.addEventListener('message', (event: MessageEvent) => {

      // only href on <a> tag
      if (event.data.type === 'navNewWindow') {
        return this.onNavNewWindow(event);
      }

      // on empty class with no http
      if (event.data.type === 'navSameWindow') {
        return this.onNavSameWindow(event);
      }

      // use class="button-webview-page" with href on <a> tag
      if (event.data.type === 'navOpenWebView') {
        return this.onNavOpenWebView(event);
      }

      // use class="button-app-page" with href on <a> tag
      if (event.data.type === 'navOpenApp') {
        return this.onNavOpenApp(event);
      }

      // use class="button-launch-game" with href on <a> tag
      if (event.data.type === 'launchGame') {
        return this.launchGame();
      }

      // use class="button-execute-method" with href on <a> tag This requires changes in webservices. 
      if (event.data.type === 'executeMethod') {
        // the basic idea is to get a method name from service and execute it our end.
        return this.webcontentExecuteService.executeMethod(event);
      }
    });

  }

  private onNavNewWindow(event: MessageEvent) {
    return this.appLinks.openExternalPage(event.data.params);
  }

  private onNavSameWindow(event: MessageEvent) {
    return this.onNavOpenWebView(event);
  }

  private onNavOpenWebView(event: MessageEvent) {
    const url = event.data.params;
    const pageName = this.utilsService.cleanPathName(url);
    this.updateExternalLink(pageName);
    this.events.publish("event:reload:externallinks");
    this.navigator.dismissAll();
    this.navigator.toWebview(false, url);
    //this.navigator.toWebview();
    //return setTimeout(() => this.navigator.pushHistoryState(pageName), 1000);
  }

  private onNavOpenApp(event?: MessageEvent): any {
    const pageName: string = event.data.params.href;
    //Media and Title are interchange to read the value in the eventValue code
    //postToParent(href, title, media) from Configuration File
    const depositCode: string = event.data.params?.title;
    const signupCode: string = event.data.params?.media;
    const params: any = {};
    if (!!depositCode) params.depositcode = depositCode;
    if (!!signupCode) params.signupcode = signupCode;
    this.checkAuthentication().then(res => {
      if (res) {
        return this.onNavOpenAppAuthenticated(pageName, params);
      } else {
        return this.onNavOpenAppNotAuthenticated(pageName, params);
      }
    });

  }

  private onNavOpenAppAuthenticated(pageName?: string, params?: any): any {
    if (pageName.charAt(0) == '/') pageName = pageName?.substring(1);
    if (pageName?.slice(0, 5) == 'CCNP_') return this.onContentPlaceholder(pageName);

    switch (pageName) {
      case 'LoginComponent':
        const messageLogin = "You are already logged in."
        this.showLoggedinPopup(messageLogin);
        break;
      case 'SignupStepOneComponent':
        const messageStepOne = "You already have an account with us. Some offers are only available for new accounts. Please see offer terms and conditions for more information."
        this.showLoggedinPopup(messageStepOne);
        break;
      case 'SignupStepTwoComponent':
        const messageStepTwo = "You already have an account with us. Some offers are only available for new accounts. Please see offer terms and conditions for more information."
        this.showLoggedinPopup(messageStepTwo);
        break;
      case 'DepositMainComponent':
        if (params && params.depositcode) {
          this.cashierContentService.updateBonusOfferValue(params.depositcode);
        }
        this.navigator.navigateTo(pageName, { multipleModals: true }, params);
        break;
      default:
        this.navigator.navigateTo(pageName, { multipleModals: true }, params);
        break;
    }
  }

  private showLoggedinPopup(message?: string) {
    const popoverComp = 'PopoverAlertComponent';

    const data: any = {
      content: message,
    };

    return this.navigator.openPopover(popoverComp, data);
  }
  externalFooterActionEvent(event) {
    if (!event || !('data' in event) || !('data' in event.data)) return;
    this.appLinks.openExternalPage(event.data.data);
  }

  internalFooterAction(event) {
    if (!event || !('data' in event) || !('data' in event.data)) return;
    let pageUrl = event.data.data;
    if (pageUrl == 'sports' || pageUrl == 'casino') {
      this.events.publish("event:tabs:load", pageUrl.toUpperCase());
    } else {
      this.events.publish("event:webview:load", pageUrl);
    }
  }


  private onNavOpenAppNotAuthenticated(pageName?: string, params?: any): any {
    if (pageName.charAt(0) == '/') pageName = pageName?.substring(1);

    switch (pageName) {
      case 'SignupStepOneComponent':
        this.navigator.navigateTo('SignupStepOneComponent');
        break;
      case 'SignupStepTwoComponent':
        this.navigator.navigateTo('SignupStepTwoComponent');
        break;
      default:
        this.lobbyService.setWaitingDialogPage(pageName);
        if (params) this.lobbyService.setWaitingDialogPageParams(params);
        this.navigator.navigateTo('LoginComponent');
        break;
    }
  }

  private launchGame(): any {
    this.gameData = this.lobbyService.getWaitingGameData();
    this.checkAuthentication().then((res) => {
      if (!res) return this.launchGameLogout(this.gameData)
      return this.gameHubControllerService.launchCasinoGame(this.gameData);
    }, error => {
      return console.error("launch game error", error)
    });
  }

  private launchGameLogout(gameData): any {
    this.lobbyService.setWaitingGameData(gameData);
    return this.navigator.navigateTo('LoginComponent');
  }

  public updateExternalLink(value: any) {
    return this._externalLinkSubject.next(value);

  }

  private onContentPlaceholder(pageName?: string) {
    const link: string = pageName?.replace("CCNP_", "");
    const cleanedLink = removeSpace(link);
    return this.navigator.navigateTo('ContentPlaceholderComponent', { multipleModals: true }, { link: cleanedLink });
  }

  getDocContentUrl(page: string) {
    const webviewConfigUrl = this.config.getConfig().WORDPRESS_URL;
    const webservicesUrl = this.config.getConfig().WEBSERVICES_URL;

    if (page != "/") page = "/" + page;
    if (page == "/home") page = "/";

    const url = `${webviewConfigUrl}${page}`;
    const fullUrl = this.springbootCheck(url);
    const clientapp = this.config.getClientApp();

    return `${webservicesUrl}/external/get-doc-content?page=${fullUrl}&clientapp=${clientapp}`;
  }

  springbootCheck(url: string): string {
    if (url[url.length - 1] != "/") return url = url + "/";
    return url;
  }

}
